import type { BaseError } from '@kiplin/web-common/error';
import type { BaseException } from '@kiplin/web-common/exception';
import { BaseEvent } from '@kiplin/web-common/event';

export type ClientGamesRefreshCompletedEventData = {
  clientId: string;
  error?: BaseError | BaseException;
  gameId: string;
  gameKind: string;
  requestId: string;
};

export class ClientGamesRefreshCompletedEvent extends BaseEvent<ClientGamesRefreshCompletedEventData> {
  public static getKey(): string {
    return 'client-games-refresh-completed';
  }

  public constructor(init: CustomEventInit<ClientGamesRefreshCompletedEventData>) {
    super(`${ClientGamesRefreshCompletedEvent.getKey()}-${init.detail?.requestId}`, init);
  }
}
